import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import split from "lodash/split";
import { createSelector } from "reselect";
import { isWalletPromoCodeSelector } from "ducks/selectors";
import { selectAppSettings } from "./appSettings";

export const myInfoDomain = state => get(state, "api.myInfo.data", {});
export const myInfoDetailsDomain = state =>
  get(state, "api.myInfoDetails.data", {});
export const myInfoOTPTokenDomain = state =>
  get(state, "api.myInfoOTPToken.data", {});

// ***************************************************************
// ******************** myInfo selectors *************************
// ***************************************************************
export const myInfoSelector = createSelector(myInfoDomain, myInfo => {
  return myInfo;
});

export const myInfoIsUsedSelector = createSelector(myInfoDomain, myInfo => {
  return get(myInfo, "isUsed", false);
});

export const myInfoLogIdSelector = createSelector(
  myInfoDetailsDomain,
  myInfoDetails => {
    return get(myInfoDetails, "myinfo_log_id", "");
  }
);

export const myInfoDetailsSelector = createSelector(
  myInfoDetailsDomain,
  myInfoDetails => {
    return myInfoDetails;
  }
);

export const myInfoAddressValidSelector = createSelector(
  myInfoDetailsDomain,
  selectAppSettings,
  (myInfoDetails, appSettings) => {
    const postalValid = !!get(myInfoDetails, "regadd.postal.value", false);
    const streetValid = !!get(myInfoDetails, "regadd.street.value", false);

    if (get(appSettings, "enable_ekyc_address_validation")) {
      return postalValid && streetValid;
    }
    return true;
  }
);

export const myInfoContactNumberValidSelector = createSelector(
  myInfoDetailsDomain,
  myInfoDetails => {
    const contactNumberValid = !!get(
      myInfoDetails,
      "mobileno.nbr.value",
      false
    );

    return contactNumberValid;
  }
);

export const myInfoDobValidSelector = createSelector(
  myInfoDetailsDomain,
  selectAppSettings,
  (myInfoDetails, appSettings) => {
    const dob = get(myInfoDetails, "dob.value", false);
    const dobSplitArray = split(dob, "-");
    const hasEmptyValues = some(dobSplitArray, isEmpty);

    if (get(appSettings, "enable_ekyc_dob_validation")) {
      return dobSplitArray.length === 3 && !hasEmptyValues;
    }
    return true;
  }
);

export const myInfoIsInvalidSelector = createSelector(
  myInfoDetailsSelector,
  myInfoIsUsedSelector,
  isWalletPromoCodeSelector,
  myInfoContactNumberValidSelector,
  myInfoAddressValidSelector,
  myInfoDobValidSelector,
  selectAppSettings,
  (
    myInfoDetails,
    myInfoIsUsed,
    isWalletPromoCode,
    myInfoContactNumberValid,
    myInfoAddressValid,
    myInfoDobValid,
    appSettings
  ) => {
    const validateEkycWithNumber =
      !isEmpty(myInfoDetails) && !myInfoContactNumberValid && myInfoIsUsed;
    const validateEkycWithWalletPromo =
      !isEmpty(myInfoDetails) &&
      isWalletPromoCode &&
      !myInfoAddressValid &&
      myInfoIsUsed;
    const validateEkycWithDob =
      !isEmpty(myInfoDetails) && !myInfoDobValid && myInfoIsUsed;
    return (
      get(appSettings, "enable_ekyc_validation") &&
      (validateEkycWithNumber ||
        validateEkycWithWalletPromo ||
        validateEkycWithDob)
    );
  }
);

// ***************************************************************
// ******************* myInfo makeSelect *************************
// ***************************************************************
export const makeSelectMyInfo = () => myInfoSelector;

export const makeSelectMyInfoIsUsed = () => myInfoIsUsedSelector;

export const makeSelectMyInfoDetails = () => myInfoDetailsSelector;

export const makeSelectMyInfoLogId = () => myInfoLogIdSelector;

export const makeSelectMyInfoOTPToken = () =>
  createSelector(myInfoOTPTokenDomain, myInfoOTPToken => {
    return myInfoOTPToken;
  });

export const makeSelectMyInfoAddressValid = () => myInfoAddressValidSelector;

export const makeSelectMyInfoContactNumberValid = () =>
  myInfoContactNumberValidSelector;

export const makeSelectMyInfoIsInvalid = () => myInfoIsInvalidSelector;

export const makeSelectMyInfoDobValid = () => myInfoDobValidSelector;
